import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-lg-row new-stepper",
  id: "kt_stepper_example_vertical",
  ref: "completeProfileStepperForm"
}
const _hoisted_2 = { class: "d-flex flex-row-auto w-300px w-lg-300px" }
const _hoisted_3 = { class: "stepper-nav flex-start p-5" }
const _hoisted_4 = { class: "flex-row-fluid p-5" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "d-flex flex-stack" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Back ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["data-kt-indicator", "disabled"]
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepperNav = _resolveComponent("StepperNav")!
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_StepperNav, {
          stepperNo: "1",
          stepperTitle: "Personal Profile",
          stepperDescription: "",
          "col-class": {
            current: _ctx.currentStep == 0,
            completed: _ctx.currentStep > 0,
          }
        }, null, 8, ["col-class"]),
        _createVNode(_component_StepperNav, {
          stepperNo: "2",
          stepperTitle: "Subscription",
          stepperDescription: "",
          "col-class": {
            current: _ctx.currentStep == 1,
            completed: _ctx.currentStep > 1,
          }
        }, null, 8, ["col-class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Form, {
        ref: "completeProfileForm",
        "initial-values": _ctx.initValues,
        "validation-schema": _ctx.formStepSchema
      }, {
        default: _withCtx(({ handleSubmit, validate, values }) => [
          _createElementVNode("form", {
            class: "form w-lg-500px mx-auto",
            onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.nextStep)), ["prevent"]),
            novalidate: "true"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex-column", { current: _ctx.currentStep === 0 }]),
                "data-kt-stepper-element": "content"
              }, [
                _createVNode(_component_Step1, {
                  values: values,
                  onOwnerStateChange: _ctx.handleOwnerStateChange,
                  onOwnerStateBlur: _ctx.handleOwnerStateBlur,
                  onOwnerCountryChange: _ctx.handleOwnerCountryChange,
                  onOwnerCountryBlur: _ctx.handleOwnerCountryBlur
                }, null, 8, ["values", "onOwnerStateChange", "onOwnerStateBlur", "onOwnerCountryChange", "onOwnerCountryBlur"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["flex-column", { current: _ctx.currentStep === 1 }]),
                "data-kt-stepper-element": "content"
              }, [
                _createVNode(_component_Step2, {
                  values: values,
                  onPlanSelected: _ctx.handlePlanSelected
                }, null, 8, ["values", "onPlanSelected"])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-new-design-secondary w-180-px me-3",
                  "data-kt-stepper-action": "previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args))),
                  disabled: _ctx.loading
                }, _hoisted_11, 8, _hoisted_9)
              ]),
              _createElementVNode("div", null, [
                (_ctx.currentStep == _ctx.totalSteps - 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-new-design-primary w-180-px",
                      "data-kt-indicator": _ctx.loading ? 'on' : null,
                      disabled: _ctx.loading,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitCompleteProfileForm && _ctx.submitCompleteProfileForm(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.buttonText), 1),
                      _hoisted_14
                    ], 8, _hoisted_12))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: validate,
                      class: "btn btn-new-design-primary w-180-px"
                    }, " Next ", 8, _hoisted_15))
              ])
            ])
          ], 40, _hoisted_5)
        ]),
        _: 1
      }, 8, ["initial-values", "validation-schema"])
    ])
  ], 512))
}